import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "26",
  viewBox: "0 0 13 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.2474 6.00033V19.417C11.2474 21.9953 9.15906 24.0837 6.58073 24.0837C4.0024 24.0837 1.91406 21.9953 1.91406 19.417V4.83366C1.91406 3.22366 3.22073 1.91699 4.83073 1.91699C6.44073 1.91699 7.7474 3.22366 7.7474 4.83366V17.0837C7.7474 17.7253 7.2224 18.2503 6.58073 18.2503C5.93906 18.2503 5.41406 17.7253 5.41406 17.0837V6.00033H3.66406V17.0837C3.66406 18.6937 4.97073 20.0003 6.58073 20.0003C8.19073 20.0003 9.4974 18.6937 9.4974 17.0837V4.83366C9.4974 2.25533 7.40906 0.166992 4.83073 0.166992C2.2524 0.166992 0.164062 2.25533 0.164062 4.83366V19.417C0.164062 22.9637 3.03406 25.8337 6.58073 25.8337C10.1274 25.8337 12.9974 22.9637 12.9974 19.417V6.00033H11.2474Z",
  fill: "#56AF40"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };